export let exportMenu2 = [
	// {
	// 	url: "/workers",
	// 	i18n: "MY_USERS",
	// 	icon: "uil-user-square",
	// 	active: false,
	// },
]